"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./Signin.css");

var _validator = require("./validator");

var _propTypes = require("prop-types");

require("@fortawesome/fontawesome-free/css/all.min.css");

require("bootstrap-css-only/css/bootstrap.min.css");

require("./mdb/css/mdb.css");

var _mdbreact = require("mdbreact");

var _reactI18next = require("react-i18next");

var CryptoJS = _interopRequireWildcard(require("crypto-js"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var encryptSecretKey = "b14ca5898a4e4133bbce2ea2315a1916";

var Signin = /*#__PURE__*/function (_Component) {
  _inherits(Signin, _Component);

  var _super = _createSuper(Signin);

  function Signin(props) {
    var _this;

    _classCallCheck(this, Signin);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "encryptData", function (data) {
      return CryptoJS.AES.encrypt(JSON.stringify(data), encryptSecretKey).toString();
    });

    _defineProperty(_assertThisInitialized(_this), "decryptData", function (data) {
      if (!data) {
        return '';
      }

      var bytes = CryptoJS.AES.decrypt(data, encryptSecretKey);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event, type, key) {
      var target = event.target;
      var value = target.value;
      var name = target.name;
      var formData = _this.state.formData;
      formData[name] = value;

      if (name === "rememberme") {
        formData[name] = event.target.checked;

        _this.isRememeberMe();
      }

      _this.setState({
        formData: formData
      });

      var validationEvent = _this.props.validationEvent ? _this.props.validationEvent : 'onchange';

      if (validationEvent === type) {
        _this.validateLoginForm(key);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateLoginForm", function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
      var errors = _this.state.formErrors;
      var formData = _this.state.formData;

      if (_this.props.UserName !== true) {
        if (key === 'all' || key === 'email') {
          if ((0, _validator.isEmpty)(formData.email)) {
            errors.email = "The Email field is required";

            _this.setState({
              isAllFieldValid: true
            });
          } else if (!(0, _validator.isEmail)(formData.email)) {
            errors.email = "Please enter a valid email";

            _this.setState({
              isAllFieldValid: true
            });
          } else {
            if (errors.hasOwnProperty('email')) delete errors["email"];
          }
        }
      }

      if (key === 'all' || key === 'password') {
        if ((0, _validator.isEmpty)(formData.password)) {
          errors.password = "The Password field is required";

          _this.setState({
            isAllFieldValid: true
          });
        } else if ((0, _validator.isContainWhiteSpace)(formData.password)) {
          errors.password = "Password should not contain white spaces";

          _this.setState({
            isAllFieldValid: true
          });
        } else if (!(0, _validator.isLength)(formData.password, {
          gte: 6,
          lte: 16,
          trim: true
        })) {
          errors.password = "Password's length must between 6 to 16";

          _this.setState({
            isAllFieldValid: true
          });
        } else {
          if (errors.hasOwnProperty('password')) delete errors["password"];
        }
      }

      if (key === 'all' || key === 'username') {
        if (_this.props.Email !== true) {
          if ((0, _validator.isEmpty)(formData.username)) {
            errors.username = "The UserName field is required";

            _this.setState({
              isAllFieldValid: true
            });
          } else {
            if (errors.hasOwnProperty('username')) delete errors["username"];
          }
        }
      }

      _this.setState({
        formErrors: errors
      });

      if ((0, _validator.isEmpty)(errors)) {
        _this.setState({
          isAllFieldValid: false,
          isFormValid: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkIfFormValid", function () {
      var errors = _this.state.errors;
      var keys = Object.keys(errors);

      if (keys.length === 0) {
        return true;
      }

      var formValid = true;

      for (var i = 0; i < keys.length; i++) {
        if (errors[keys[i]]) {
          formValid = false;
          break;
        }
      }

      return formValid;
    });

    _defineProperty(_assertThisInitialized(_this), "setRememberMeData", function () {
      // if login details are valid and remember me is checked, store the details in localstorage    
      if (_this.state.isFormValid) {
        // if remember me is in form data
        if (_this.state.formData.hasOwnProperty('rememberme') && _this.state.formData.rememberme) {
          if (_this.state.formData.rememberme) {
            // set info into the localstorage
            var fields = Object.keys(_this.state.formData);
            fields.map(function (field, index) {
              localStorage[field] = _this.encryptData(_this.state.formData[field]);
              return field;
            });
          }
        } else {
          // user has unchecked the remember me 
          // then check if there is some user data in local storage then remove that
          if (localStorage.hasOwnProperty('rememberme')) {
            var _fields = ['username', 'email', 'password', 'rememberme'];

            _fields.map(function (field) {
              localStorage.removeItem(field);
              return field;
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "login", function (e) {
      e.preventDefault();

      _this.validateLoginForm('all');

      _this.props.onSubmit(e, _this.state);

      _this.setRememberMeData();
    });

    _defineProperty(_assertThisInitialized(_this), "isRememeberMe", function () {
      _this.props.onChange(_this.state);
    });

    _defineProperty(_assertThisInitialized(_this), "forgotpass", function (e) {
      _this.props.onClick(e, _this.state);
    });

    _defineProperty(_assertThisInitialized(_this), "registerClick", function (e) {
      if (_this.props.registerClick) {
        _this.props.registerClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "togglePasswordField", function (e) {
      _this.setState({
        showPasswordInput: !_this.state.showPasswordInput
      });
    });

    _this.state = {
      formData: {},
      // Contains login form data
      formErrors: {},
      // Contains login field errors
      formSubmitted: false,
      // Indicates submit status of login form
      loading: false,
      // Indicates in progress state of login form
      isAllFieldValid: true,
      showPasswordInput: false,
      isFormValid: false
    };
    var textIconClass = '';
    var iconInputParent = '';
    return _this;
  } // function to encrypt the localstorage


  _createClass(Signin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var fields = ['username', 'email', 'password', 'rememberme'];
      var rememberMeData = {};
      fields.map(function (field, index) {
        if (localStorage.hasOwnProperty(field)) {
          rememberMeData[field] = _this2.decryptData(localStorage[field]);
        }

        return field;
      });

      if (Object.keys(rememberMeData).length > 0) {
        this.setState({
          formData: rememberMeData
        }, this.validateLoginForm);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var t = this.props.t; //const {formSubmitted, isAllFieldValid } = this.state;

      var errors = this.state.formErrors;
      Object.assign(errors, this.props.extErrors);
      var disabled = this.props.disableSubmit === false ? false : this.state.isAllFieldValid;
      var titleAlignClass = this.props.titleAlign && this.props.titleAlign == 'left' ? 'text-left' : 'text-center';
      var registerAllignClass = this.props.registerLinkAlign ? 'text-' + this.props.registerLinkAlign : 'text-left';
      this.textIconClass = this.props.showIcons ? 'icon-input' : '';
      this.iconInputParent = this.props.showIcons ? 'icon-input-wrap' : '';

      if (disabled) {
        this.state.errors = {};
      }

      if (this.props.design === 'material') {
        return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBContainer, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "12"
        }, /*#__PURE__*/_react.default.createElement("form", {
          onSubmit: this.login
        }, this.props.onRenderTitle ? this.props.onRenderTitle() : /*#__PURE__*/_react.default.createElement("p", {
          className: titleAlignClass + " h5 mb-4"
        }, t(this.props.Title)), this.props.additionalHeading ? /*#__PURE__*/_react.default.createElement("div", null, this.props.additionalHeading, " ") : '', /*#__PURE__*/_react.default.createElement("div", {
          className: "general-error text-danger"
        }, t(errors.general)), /*#__PURE__*/_react.default.createElement("div", {
          className: "grey-text"
        }, this.props.UserName ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
          label: t(this.props.LableUsername),
          icon: this.props.usernameIcon,
          type: "text",
          name: "username",
          placeholder: t(this.props.PlaceholderUsername ? this.props.PlaceholderUsername : 'Enter your username'),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'username');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'username');
          },
          className: errors.username ? 'is-invalid' : '',
          outline: this.props.materialOutline,
          value: this.state.formData.username,
          success: "right"
        }, errors.username && /*#__PURE__*/_react.default.createElement("span", {
          className: "text-danger"
        }, t(errors.username))) : null, this.props.Email ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
          label: t(this.props.LableEmail ? this.props.LableEmail : "Email"),
          icon: this.props.emailIcon,
          type: "text",
          name: "email",
          placeholder: t(this.props.PlaceholderEmail ? this.props.PlaceholderEmail : "Enter your email"),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'email');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'email');
          },
          className: errors.email ? 'is-invalid' : '',
          outline: this.props.materialOutline,
          value: this.state.formData.email,
          autocomplete: this.props.autoCompleteOption,
          success: "right"
        }, errors.email && /*#__PURE__*/_react.default.createElement("span", {
          className: "text-danger"
        }, t(errors.email))) : null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
          label: t(this.props.LablePassword ? this.props.LablePassword : "Password"),
          icon: this.props.passwordIcon,
          type: this.state.showPasswordInput ? 'text' : 'password',
          name: "password",
          placeholder: t(this.props.PlaceholderPassword ? this.props.PlaceholderPassword : "Enter your password"),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'password');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'password');
          },
          className: errors.password ? 'is-invalid' : '',
          outline: this.props.materialOutline,
          value: this.state.formData.password,
          autocomplete: this.props.autoCompleteOption,
          success: "right"
        }, this.props.showPassword && this.state.showPasswordInput ? /*#__PURE__*/_react.default.createElement("i", {
          onClick: this.togglePasswordField,
          className: "fa fa-eye-slash icon-show-password"
        }) : '', this.props.showPassword && !this.state.showPasswordInput ? /*#__PURE__*/_react.default.createElement("i", {
          onClick: this.togglePasswordField,
          className: "fa fa-eye icon-show-password"
        }) : '', errors.password && /*#__PURE__*/_react.default.createElement("span", {
          className: "text-danger"
        }, t(errors.password))), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "6"
        }, this.props.RememberMe ? /*#__PURE__*/_react.default.createElement("div", {
          className: "form-check"
        }, /*#__PURE__*/_react.default.createElement("input", {
          className: "form-check-input",
          type: "checkbox",
          name: "rememberme",
          checked: Boolean(this.state.formData.rememberme),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, "onchange", "rememberme");
          }
        }), /*#__PURE__*/_react.default.createElement("label", {
          className: "grey-text"
        }, t("Remember Me"))) : null), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "6"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "md-form form-group"
        }, this.props.ForgotPassword ? /*#__PURE__*/_react.default.createElement("p", {
          className: "forgot-password"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "#",
          onClick: function onClick(e) {
            return _this3.forgotpass(e);
          }
        }, t(this.props.ForgotPasswordText ? this.props.ForgotPasswordText : 'Forgot Password'))) : null))), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "12"
        }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBBtn, {
          type: "submit",
          disabled: disabled,
          className: "btn btn-primary" // className={isAllFieldValid ? "btn btn-primary" : "disableSubmit"}

        }, t(this.props.SubmitButtonText ? this.props.SubmitButtonText : 'Submit')))), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "12"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: registerAllignClass + " form-group"
        }, this.props.registerText ? /*#__PURE__*/_react.default.createElement("p", {
          className: "new-user"
        }, /*#__PURE__*/_react.default.createElement("a", {
          onClick: function onClick(e) {
            _this3.registerClick(e);
          },
          href: this.props.registerLink
        }, t(this.props.registerText))) : null))))))));
      } else {
        return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBContainer, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "12"
        }, /*#__PURE__*/_react.default.createElement("form", {
          onSubmit: this.login
        }, this.props.onRenderTitle ? this.props.onRenderTitle() : /*#__PURE__*/_react.default.createElement("p", {
          className: titleAlignClass + " h5 mb-4"
        }, t(this.props.Title)), this.props.additionalHeading ? /*#__PURE__*/_react.default.createElement("div", null, this.props.additionalHeading, " ") : '', /*#__PURE__*/_react.default.createElement("div", {
          className: "general-error text-danger"
        }, t(errors.general)), this.props.UserName ? /*#__PURE__*/_react.default.createElement("div", {
          className: this.iconInputParent
        }, this.props.LableUsername ? /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: "username",
          className: "grey-text"
        }, t(this.props.LableUsername)) : "", this.props.showIcons ? /*#__PURE__*/_react.default.createElement("div", {
          className: "inputBox"
        }, /*#__PURE__*/_react.default.createElement("input", {
          type: "text",
          id: "username",
          name: "username",
          placeholder: t(this.props.PlaceholderUsername ? this.props.PlaceholderUsername : 'Enter your username'),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'username');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'username');
          },
          value: this.state.formData.username,
          className: errors.username ? 'form-control is-invalid ' + this.textIconClass : 'form-control ' + this.textIconClass
        }), /*#__PURE__*/_react.default.createElement("i", {
          className: this.props.usernameIconClass + " text-icon"
        })) : /*#__PURE__*/_react.default.createElement("input", {
          type: "text",
          id: "username",
          name: "username",
          placeholder: t(this.props.PlaceholderUsername ? this.props.PlaceholderUsername : 'Enter your username'),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'username');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'username');
          },
          value: this.state.formData.username,
          className: errors.username ? 'form-control is-invalid ' + this.textIconClass : 'form-control ' + this.textIconClass
        }), errors.username && /*#__PURE__*/_react.default.createElement("span", {
          className: "text-danger"
        }, t(errors.username)), /*#__PURE__*/_react.default.createElement("br", null)) : null, this.props.Email ? /*#__PURE__*/_react.default.createElement("div", {
          className: this.iconInputParent
        }, this.props.LableEmail ? /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: "email",
          className: "grey-text"
        }, t(this.props.LableEmail)) : "", this.props.showIcons ? /*#__PURE__*/_react.default.createElement("div", {
          className: "inputBox"
        }, /*#__PURE__*/_react.default.createElement("input", {
          type: "text",
          id: "email",
          name: "email",
          placeholder: t(this.props.PlaceholderEmail ? this.props.PlaceholderEmail : "Enter your email"),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'email');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'email');
          },
          value: this.state.formData.email,
          className: errors.email ? 'form-control is-invalid ' + this.textIconClass : 'form-control ' + this.textIconClass
        }), /*#__PURE__*/_react.default.createElement("i", {
          className: this.props.emailIconClass + " text-icon"
        })) : /*#__PURE__*/_react.default.createElement("input", {
          type: "text",
          id: "email",
          name: "email",
          placeholder: t(this.props.PlaceholderEmail ? this.props.PlaceholderEmail : "Enter your email"),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'email');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'email');
          },
          value: this.state.formData.email,
          className: errors.email ? 'form-control is-invalid ' + this.textIconClass : 'form-control ' + this.textIconClass
        }), errors.email && /*#__PURE__*/_react.default.createElement("span", {
          className: "text-danger"
        }, t(errors.email)), /*#__PURE__*/_react.default.createElement("br", null)) : null, /*#__PURE__*/_react.default.createElement("div", {
          className: this.iconInputParent
        }, this.props.LablePassword ? /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: "email",
          className: "grey-text"
        }, t(this.props.LablePassword)) : '', this.props.showIcons ? /*#__PURE__*/_react.default.createElement("div", {
          className: "inputBox"
        }, /*#__PURE__*/_react.default.createElement("input", {
          type: this.state.showPasswordInput ? 'text' : 'password',
          name: "password",
          id: "password",
          placeholder: t(this.props.PlaceholderPassword ? this.props.PlaceholderPassword : "Enter your password"),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'password');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'password');
          },
          value: this.state.formData.password,
          className: errors.password ? 'form-control is-invalid ' + this.textIconClass : 'form-control ' + this.textIconClass
        }), /*#__PURE__*/_react.default.createElement("i", {
          className: this.props.passwordIconClass + " text-icon"
        }), this.props.showPassword && this.state.showPasswordInput ? /*#__PURE__*/_react.default.createElement("i", {
          onClick: this.togglePasswordField,
          className: "fa fa-eye-slash icon-show-password"
        }) : '', this.props.showPassword && !this.state.showPasswordInput ? /*#__PURE__*/_react.default.createElement("i", {
          onClick: this.togglePasswordField,
          className: "fa fa-eye icon-show-password"
        }) : '') : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
          type: this.state.showPasswordInput ? 'text' : 'password',
          name: "password",
          id: "password",
          placeholder: t(this.props.PlaceholderPassword ? this.props.PlaceholderPassword : "Enter your password"),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'password');
          },
          onBlur: function onBlur(e) {
            return _this3.handleInputChange(e, 'blur', 'password');
          },
          value: this.state.formData.password,
          className: errors.password ? 'form-control is-invalid ' + this.textIconClass : 'form-control ' + this.textIconClass
        }), this.props.showPassword && this.state.showPasswordInput ? /*#__PURE__*/_react.default.createElement("i", {
          onClick: this.togglePasswordField,
          className: "fa fa-eye-slash icon-show-password"
        }) : '', this.props.showPassword && !this.state.showPasswordInput ? /*#__PURE__*/_react.default.createElement("i", {
          onClick: this.togglePasswordField,
          className: "fa fa-eye icon-show-password"
        }) : ''), errors.password && /*#__PURE__*/_react.default.createElement("span", {
          className: "text-danger"
        }, t(errors.password)), /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "6"
        }, this.props.RememberMe ? /*#__PURE__*/_react.default.createElement("div", {
          className: "form-check"
        }, /*#__PURE__*/_react.default.createElement("input", {
          className: "form-check-input",
          type: "checkbox",
          name: "rememberme",
          checked: Boolean(this.state.formData.rememberme),
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, 'onchange', 'rememberme');
          }
        }), /*#__PURE__*/_react.default.createElement("label", {
          className: "grey-text"
        }, t("Remember Me"))) : null), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "6"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "md-form form-group"
        }, this.props.ForgotPassword ? /*#__PURE__*/_react.default.createElement("p", {
          className: "forgot-password"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "#",
          onClick: function onClick(e) {
            return _this3.forgotpass(e);
          }
        }, t(this.props.ForgotPasswordText ? this.props.ForgotPasswordText : 'Forgot Password'))) : null))), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "12"
        }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBBtn, {
          color: "indigo",
          type: "submit",
          disabled: disabled,
          className: "btn btn-primary" // className={isAllFieldValid ? "btn btn-primary" : "disableSubmit"}

        }, t(this.props.SubmitButtonText ? this.props.SubmitButtonText : 'Submit')))), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
          md: "12"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: registerAllignClass + " form-group"
        }, this.props.registerText ? /*#__PURE__*/_react.default.createElement("p", {
          className: "new-user"
        }, /*#__PURE__*/_react.default.createElement("a", {
          onClick: function onClick(e) {
            _this3.registerClick(e);
          },
          href: this.props.registerLink
        }, t(this.props.registerText))) : null)))))));
      }
    }
  }]);

  return Signin;
}(_react.Component);

_defineProperty(Signin, "propTypes", {
  Username: _propTypes.PropTypes.bool,
  Email: _propTypes.PropTypes.bool,
  ForgotPassword: _propTypes.PropTypes.bool,
  RememberMe: _propTypes.PropTypes.bool,
  Title: _propTypes.PropTypes.string,
  SubmitButtonText: _propTypes.PropTypes.string,
  ForgotPasswordText: _propTypes.PropTypes.string,
  LableUsername: _propTypes.PropTypes.string,
  PlaceholderUsername: _propTypes.PropTypes.string,
  LableEmail: _propTypes.PropTypes.string,
  PlaceholderEmail: _propTypes.PropTypes.string,
  LablePassword: _propTypes.PropTypes.string,
  PlaceholderPassword: _propTypes.PropTypes.string,
  onSubmit: _propTypes.PropTypes.func,
  onChange: _propTypes.PropTypes.func,
  onClick: _propTypes.PropTypes.func,
  design: _propTypes.PropTypes.string,
  additionalHeading: _propTypes.PropTypes.any,
  registerLink: _propTypes.PropTypes.string,
  registerText: _propTypes.PropTypes.string,
  registerLinkAlign: _propTypes.PropTypes.string,
  autocomplete: _propTypes.PropTypes.string
});

var _default = (0, _reactI18next.withTranslation)()(Signin);

exports.default = _default;